import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import createMarkup from '../../../_utils/murkup';
import SpoilerInfo from '../common/SpoilerInfo.jsx';
import tinycontentAPI from '../../../_api/tinycontent';


class PurchasesInfo extends React.Component {
  static propTypes = {
    lang: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      info: null
    }
  }

  componentDidMount() {
    const infoName = 'purchases:' + this.props.lang;
    const response = tinycontentAPI.get(infoName);
    if (response) this.setState({ info: response.content });
  }
  render() {
    if (this.state.info){
      return <SpoilerInfo>
        <div dangerouslySetInnerHTML={ createMarkup(this.state.info) }></div>
      </SpoilerInfo>;
    }
    return <></>;
  }
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
  }
};
export default compose(connect(mapStateToProps, {}))(PurchasesInfo);
